import React, { lazy } from 'react';
import { useScrollReveal } from '../hooks/useScrollReveal';
import { StarIcon } from './Icons';
export function TestimonialSection() {
  const imgReveal = useScrollReveal();
  const card1 = useScrollReveal();
  const card2 = useScrollReveal();
  return <section className="py-20 bg-sage/5" data-id="element-210">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-211">
        <div className="text-center mb-16" data-id="element-212">
          <h2 className="text-3xl md:text-4xl font-playfair font-bold text-charcoal mb-4" data-id="element-213">
            Mujeres reales. Resultados reales.
          </h2>
          <p className="text-lg text-charcoal-light font-sans" data-id="element-214">
            No estás sola en esto. Miles de mujeres ya han recuperado su
            metabolismo.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center" data-id="element-215">
          <div ref={imgReveal.ref} className={`lg:col-span-5 reveal-left ${imgReveal.isVisible ? 'visible' : ''}`} data-id="element-216">
            <div className="relative rounded-2xl overflow-hidden shadow-xl" data-id="element-217">
              <img src="https://cdn.magicpatterns.com/uploads/dqMzQsSFScAUPY6cyQYp1E/reset352B.png" alt="Mujer disfrutando de su bienestar" className="w-full h-auto object-cover" loading="lazy" data-id="element-218" />
            </div>
          </div>

          <div className="lg:col-span-7 space-y-8" data-id="element-219">
            <div ref={card1.ref} className={`bg-white p-8 rounded-2xl shadow-sm border border-cream relative reveal ${card1.isVisible ? 'visible' : ''}`} data-id="element-220">
              <div className="flex text-gold mb-4" data-id="element-221">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5" data-id="element-222" />)}
              </div>
              <p className="text-lg text-charcoal-light font-sans italic mb-6 leading-relaxed" data-id="element-223">
                "A los 43 pensaba que mi cuerpo ya no respondería. Había probado
                el ayuno y el HIIT y solo me sentía más gorda e inflamada. Con
                el Reseteo Hormonal H2 bajé 4 kilos en los primeros 15 días,
                pero lo mejor es que mi cintura volvió y ya no tengo esa
                ansiedad por el dulce de medianoche."
              </p>
              <div className="flex items-center justify-between border-t border-cream pt-4" data-id="element-224">
                <p className="font-playfair font-bold text-charcoal" data-id="element-225">
                  Laura M., 43 años
                </p>
                <p className="text-sm font-sans text-sage-dark font-medium bg-sage/10 px-3 py-1 rounded-full" data-id="element-226">
                  Resultado: -6kg en 30 días
                </p>
              </div>
            </div>

            <div ref={card2.ref} className={`bg-white p-8 rounded-2xl shadow-sm border border-cream relative reveal delay-100 ${card2.isVisible ? 'visible' : ''}`} data-id="element-227">
              <div className="flex text-gold mb-4" data-id="element-228">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5" data-id="element-229" />)}
              </div>
              <p className="text-lg text-charcoal-light font-sans italic mb-6 leading-relaxed" data-id="element-230">
                "Lo que más me gusta es no tener que pesar la comida. Por
                primera vez en años, duermo toda la noche seguida. Mi energía
                cambió por completo y la gente me pregunta qué me he hecho en la
                cara, ¡estoy desinflamada!"
              </p>
              <div className="flex items-center justify-between border-t border-cream pt-4" data-id="element-231">
                <p className="font-playfair font-bold text-charcoal" data-id="element-232">
                  Carmen R., 39 años
                </p>
                <p className="text-sm font-sans text-sage-dark font-medium bg-sage/10 px-3 py-1 rounded-full" data-id="element-233">
                  Resultado: Adiós hinchazón
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}